import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userLogOut } from "../reducers/commonReducer";
import {
  home,
  settings,
  users,
} from "../const";
import { Button } from "react-bootstrap";

const SideMenu = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [inactive, setInactive] = useState(false);
  const logOut = () => {
    dispatch(
      userLogOut({ "x-auth-token": localStorage.getItem("x-auth-token") })
    );
    localStorage.removeItem("x-auth-token");
    localStorage.removeItem("userRole");
    navigate(home);
  };
  return (
    <>
      <div className="row print-hide">
        <div className="col">
          <div className={`side-menu ${inactive ? "inactive" : ""}`}>
            <div className="top-section">
              <div className="bg-white p-2">
                <img src={process.env.REACT_APP_LOGO} alt="logo"/>
              </div>
              <ul className="nav side-links fs-3 flex-column">
                {localStorage.getItem("x-auth-token") &&
                  localStorage.getItem("slug") == "admin" && (
                    <>
                     <NavLink to={users}>
                        {inactive ? (
                          <i className="bi bi-people me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-people me-2 ds"></i>
                                Users
                                <hr />
                              </span>
                            </li>
                          </span>
                        )}
                      </NavLink>
                      <NavLink to={`/whatsapp`}>
                        {inactive ? (
                          <i className="bi bi-chat-dots-fill"></i>
                        ) : (
                          <span className="border-bottom">
                            
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-chat-dots-fill"></i> Whatsapp
                                <hr />
                              </span>
                            </li>
                          </span>
                        )}
                      </NavLink>
                      <NavLink to={`/templates`}>
                        {inactive ? (
                          <i className="bi bi-card-checklist"></i>
                        ) : (
                          <span className="border-bottom">
                            
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-card-checklist"></i> Templates
                                <hr />
                              </span>
                            </li>
                          </span>
                        )}
                      </NavLink>
                      <NavLink to={settings}>
                        {inactive ? (
                          <i className="bi bi-gear me-2 "></i>
                        ) : (
                          <span className="border-bottom">
                            
                            <li className="nav-item">
                              <span
                                className="nav-link sideMenuLinks"
                                aria-current="page"
                                href="#"
                              >
                                <i className="bi bi-gear me-2 ds"></i>
                                Settings
                                <hr />
                              </span>
                            </li>
                          </span>
                        )}
                      </NavLink>
                      {/* old */}
                    </>
                  )}
              </ul>
            </div>
          </div>
        </div>

        <div className="col">
          <div className={`${inactive ? "content-active" : "content"}`}>
            <div className="bg-side border-dark border-bottom">
              <div className="p-2 text-end">
                <Button variant="danger" onClick={logOut} className="btn btn-outline-primary">
                  <span
                    className="nav-link text-white"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Log Out
                  </span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideMenu;
